up.compiler('[public_url]', function(element) {
  let publicURL = element.getAttribute('public_url')
  let anchor = window.location.href.split(/(?=#)/g)[1]
  if (anchor) { publicURL += anchor }
  up.history.replace(publicURL);
});
